import React, { FC, useContext } from "react";
import { Bar } from "react-chartjs-2";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Box, Tab } from "@mui/material";
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";
import { IChart } from "../../common/interfaces/chart.interface";
import { useTabContext } from "../../context/tabs/TabContext";
import { PeriodFilter } from "../../common/enums/common.enums";

Chart.register(CategoryScale);
interface IBarChart {
  chartData: IChart[] | undefined;
}

const options = {
  responsive: true,
  scales: {
    x: {
      ticks: {
        display: false,
      },
    },
  },
};

const BarChart: FC<IBarChart> = (props) => {
  const { tab, changeTab } = useContext(useTabContext);
  const handleChange = (
    event: React.SyntheticEvent,
    newValue: PeriodFilter
  ) => {
    changeTab(newValue);
  };

  return (
    <div>
      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={tab}>
          <Box sx={{ width: "100%", typography: "body1" }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              {props.chartData &&
                props.chartData.map((child, index) => (
                  <Tab
                    label={child.title}
                    value={child.id.toUpperCase()}
                    key={index}
                  />
                ))}
            </TabList>
            {props.chartData &&
              props.chartData.map((child, index) => (
                <TabPanel value={child.id.toUpperCase()} key={index}>
                  <Box
                    sx={{
                      backgroundColor: "transparent",
                      borderRadius: 0.5,
                    }}
                  >
                    <Bar options={options} data={child.data} />
                  </Box>
                </TabPanel>
              ))}
          </Box>
        </TabContext>
      </Box>
    </div>
  );
};

export default BarChart;
